import styled, { css } from "styled-components";

const UserAccountDetailsCard = styled.div`
	display: flex;
	flex-direction: column;
	border-radius: 20px;
	background: var(--profile-page-wrapper-bg);
	padding: 10px;
`;

const CardHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	color: var(--profile-card-text-color);
	text-align: center;
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
	margin-bottom: 10px;
`;

const CardContent = styled.div`
	display: flex;
	.change-password-button {
		border-radius: 25px;
		display: flex;
		height: 40px;
		width: 100%;
		justify-content: center;
		align-items: center;
		align-self: stretch;
		color: #fff;
		text-align: center;
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
		${window.HAS_LESS_BORDER_RADIUS &&
		css`
			border-radius: 10px;
		`}

		background: var(--profile-card-button-bg);
		color: var(--button-color);
		opacity: 0.6;

		svg {
			path {
				fill: var(--button-color);
			}
		}
	}
	.ant-form {
		display: flex;
		flex-direction: column;
		gap: 10px;
		width: 100%;
	}

	.ant-input {
		color: var(--content-text-color) !important;
		font-size: 12px !important;
		font-weight: 400 !important;
		line-height: 16px !important;
		letter-spacing: 0.3px !important;
		width: 100%;
		height: 40px;
		padding: 10px 5px 0 20px !important;
		border-radius: 50px;
		border: 1px solid var(--profile-card-text-color);
		background: var(--input-bg-has-value) !important;
	}

	.ant-input[disabled] {
		border: 1px solid var(--profile-card-text-color) !important;
	}

	.ant-input[disabled]:hover {
		border: 1px solid var(--profile-card-text-color);
	}

	.ant-form-item {
		margin-bottom: 0px;
		position: relative;

		.ant-form-item-label {
			position: absolute;
			z-index: 1;
			top: 5px;
			left: 21px;
			height: 12px;
			display: flex;
			align-items: center;

			& > label {
				color: var(--main-secondary-text-color);
				font-size: 10px;
				font-weight: 400;
				line-height: 12px;
				letter-spacing: 0.25px;
				height: 100%;
			}
		}

		&.switch-form-item {
			justify-content: center;
			.ant-form-item-label {
				position: relative;
				width: 85px;
			}
		}
	}

	.ant-form-item textarea.ant-input {
		width: 100%;
		min-height: 64px;
		padding: 15px 10px 0 20px !important;
		border-radius: 20px;
	}

	${({ hasLessBorderRadius }) =>
		hasLessBorderRadius &&
		css`
			.ant-input {
				border-radius: 10px;
			}

			input {
				border-radius: 10px;
			}

			.ant-form-item textarea.ant-input {
				border-radius: 10px;
			}
		`}
`;

export { CardContent, CardHeader, UserAccountDetailsCard };
